// components/SeoSection.tsx
import React from "react";
import Row from "@components/row";
import Fields from "@components/fields";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import Column from "@components/column";

interface SeoSectionProps {
  values: any;
}

export const SeoSection: React.FC<SeoSectionProps> = ({ values }) => {
  return (
    <FieldWrapper styleWrapper="width:98%">
      <Typography styleText="font-size:16px;font-weight:600;margin-bottom:10px">
        Tags and SEO
      </Typography>
      <Fields.TagInput
        name="tags"
        label="Tags"
        placeholder="Type and enter to add tags"
        icon={false}
        styleWrapper="width:98.5%"
      />
      <br />
      <Row>
        <div style={{ flex: 3, width: "100%" }}>
          <Column>
            <Fields.Input
              name="title"
              placeholder="Type Here"
              label="Meta Title"
            />
            <Fields.Input
              name="keyword"
              placeholder="Type Here"
              label="Meta Keywords"
            />
            <Fields.Editor
              name="descriptionMeta"
              label="Meta Description"
            />
          </Column>
        </div>
        <div style={{ flex: 1, width: "100%" }}>
          <Fields.Upload name="og" label="Og Image" />
        </div>
      </Row>
    </FieldWrapper>
  );
};